<template>
  <div :class="`message ${theme.isDark ? 'message_dark' : null}`">
    <div class="message__info">
      <p class="message__author">{{ author }}</p>
      <p class="message__date">
        <span>{{ date }} </span>
        <span>{{ time }}</span>
        <v-btn @click="deleteMessage" icon x-small class="ml-1">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </p>
    </div>
    <p class="text-subtitle-1 message__text">
      {{ text }}
    </p>
  </div>
</template>

<script>
import SortService from "@/services/sort.service";
import { mdiDelete } from "@mdi/js";

export default {
  name: "Note",
  inject: ["theme"],
  props: {
    author: String,
    created: String,
    text: String,
    deleteMessage: Function,
  },
  data() {
    return {
      date: SortService.sortDate(this.created)[0],
      time: SortService.sortDate(this.created)[1],
      icons: {
        mdiDelete,
      },
    };
  },
};
</script>
